/**
 * Copyright Highway9 Networks Inc.
 *
 * Highcharts modules patch the shared Highcharts instance globally, so the
 * export menu is only available once some module has registered it. Registering
 * here keeps it independent of which chart component happens to load first
 * (it used to ride on an eager import of the Ziva chat chart) - MCS-4316.
 */
import * as Highcharts from "highcharts";
import ExportingModule from "highcharts/modules/exporting";

function applyHighchartsModule(mod: unknown): void {
  const fn =
    typeof mod === "function"
      ? mod
      : mod && typeof mod === "object" && "default" in mod && typeof (mod as { default: unknown }).default === "function"
        ? (mod as { default: (hc: typeof Highcharts) => void }).default
        : null;
  if (fn) fn(Highcharts);
}

applyHighchartsModule(ExportingModule);
